<template>
  <div class="chart-footer">
    <div class="chart-footer__box">
      <BaseText
        class="chart-footer__label"
        :color="NebraskaColors.textSecondary"
        size="xs"
        data-testid="start-date"
      >
        {{ formattedStartDate }}
      </BaseText>
    </div>
    <button
      v-if="showFooterTextAsButton && footerText"
      class="chart-footer__button"
      type="button"
      aria-label="Atualizar gráfico"
      data-testid="footer-button"
      :aria-disabled="isFooterButtonDisabled"
      @click="handleFooterButtonClick"
    >
      <BaseIcon
        class="chart-footer__button__icon"
        :class="computedClassName"
        icon="ic_redo"
        :color="NebraskaColors.textSecondary"
        height="14px"
      />
      <BaseText :color="NebraskaColors.textSecondary" size="xs">
        {{ footerText }}
      </BaseText>
    </button>
    <BaseText
      v-else-if="footerText"
      class="chart-footer__text"
      :color="NebraskaColors.textSecondary"
      size="xs"
    >
      {{ footerText }}
    </BaseText>
    <div class="chart-footer__box">
      <BaseText
        class="chart-footer__label"
        :color="NebraskaColors.textSecondary"
        size="xs"
        data-testid="end-date"
      >
        {{ formattedEndDate }}
      </BaseText>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, BaseIcon } from '@warrenbrasil/nebraska-web';
import { dateViewer } from '@/modules/common/helpers/date';

@Component({
  name: 'ChartFooter',
  components: { BaseText, BaseIcon }
})
export default class ChartFooter extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @Prop({ type: String, required: true })
  readonly startDate!: string;

  @Prop({ type: String, required: true })
  readonly endDate!: string;

  @Prop({ type: String, required: false })
  readonly footerText?: string;

  @Prop({ type: Boolean, default: false })
  readonly showFooterTextAsButton!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isProcessing!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  @Prop({ type: String, default: 'DD/MMM' })
  readonly dateFormat!: string;

  get formattedStartDate() {
    return dateViewer(this.startDate, this.dateFormat);
  }

  get formattedEndDate() {
    return dateViewer(this.endDate, this.dateFormat);
  }

  get computedClassName() {
    return this.isProcessing ? 'chart-footer__button__spin' : '';
  }

  get isFooterButtonDisabled() {
    return this.isProcessing || this.disabled;
  }

  handleFooterButtonClick() {
    if (this.isFooterButtonDisabled) return;
    this.emitFooterButtonClick();
  }

  @Emit('footer-button-click')
  emitFooterButtonClick() {}
}
</script>

<style lang="less" scoped>
.chart-footer {
  display: flex;
  padding: 0 @size-spacing-x350;

  &__box {
    flex: 1;
    justify-content: center;

    &:first-child .chart-footer__label {
      text-align: left;
    }

    &:last-child > .chart-footer__label {
      text-align: right;
    }
  }

  &__text {
    text-align: center;
    padding: 0 @size-spacing-x350;
  }

  &__button {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 @size-spacing-x350;

    &__icon {
      display: flex;
      align-items: center;
    }

    &__spin {
      animation-name: spin-animation;
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      display: flex;
      align-items: center;
    }
  }
}
@keyframes spin-animation {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
